<template>
  <div>
    <v-card class="pb-2" flat style="border-radius: 5px">
      <v-toolbar class="body-2 beez-bold " dense flat>
        {{ title }}
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn flat icon @click="refresh" :loading="loader">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn flat icon @click="saveChanges" :loading="loader">
            <v-icon>save</v-icon>
          </v-btn>
          <v-btn flat icon @click="showRole = !showRole">
            <v-icon>{{ showRole ? 'expand_less' : 'expand_more' }} </v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text v-if="showRole">
        <v-layout align-start justify-center row wrap>
          <v-flex sm12 md6 lg4>
            <v-card class="ma-1" style="border-radius: 5px">
              <v-toolbar class="body-2 beez-bold " dense flat>
                Honey Privileges
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="searchHoney"
                  color="secondary"
                  label="Search for Role"
                >
                </v-text-field>
                <v-data-table
                  :search="searchHoney"
                  :loading="loader"
                  :headers="headersHoney"
                  :items="honeyPrivileges"
                  item-key="role"
                  :rows-per-page-items="headerPageItems"
                >
                  <template v-slot:items="props">
                    <td>
                      <v-checkbox
                        v-model="props.item.assigned"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.role }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex sm12 md6 lg4>
            <v-card class="ma-1" style="border-radius: 5px">
              <v-toolbar class="body-2 beez-bold " dense flat>
                Table Privileges
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="searchTable"
                  color="secondary"
                  label="Search for Role"
                >
                </v-text-field>
                <v-data-table
                  :search="searchTable"
                  :loading="loader"
                  :headers="headersTable"
                  :items="tablePrivileges"
                  item-key="role"
                  :rows-per-page-items="headerPageItems"
                >
                  <template v-slot:items="props">
                    <td>
                      <v-checkbox
                        v-model="props.item.assigned"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.role }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex sm12 md6 lg4>
            <v-card class="ma-1" style="border-radius: 5px">
              <v-toolbar class="body-2 beez-bold " dense flat>
                API Privileges
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="searchAPI"
                  color="secondary"
                  label="Search for Role"
                >
                </v-text-field>
                <v-data-table
                  :search="searchAPI"
                  :loading="loader"
                  :headers="headersAPI"
                  :items="apiPrivileges"
                  item-key="role"
                  :rows-per-page-items="headerPageItems"
                >
                  <template v-slot:items="props">
                    <td>
                      <v-checkbox
                        v-model="props.item.assigned"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.role }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'RoleConfiguration',
  props: {
    title: String,
    id: String
  },
  data() {
    return {
      loader: false,
      showRole: false,
      searchTable: null,
      searchHoney: null,
      searchAPI: null,
      tablePrivileges: [],
      honeyPrivileges: [],
      apiPrivileges: [],
      currentRole: {},
      headerPageItems: [20, 100, { text: 'All', value: -1 }],
      headersTable: [
        { text: 'Assigned', value: 'assigned' },
        { text: 'Role', value: 'role', align: 'left' }
      ],
      headersHoney: [
        { text: 'Assigned', value: 'assigned' },
        { text: 'Role', value: 'role', align: 'left' }
      ],
      headersAPI: [
        { text: 'Assigned', value: 'assigned' },
        { text: 'Role', value: 'role', align: 'left' }
      ]
    }
  },
  computed: {
    ...mapState({
      honeyRoles: state => state.honeyRoles.honeyRoles,
      privileges: state => state.honeyRoles.privileges
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.syncPrivileges()
  },
  watch: {
    privileges() {
      this.syncPrivileges()
    },
    honeyRoles() {
      this.syncPrivileges()
    }
  },
  methods: {
    async refresh() {
      this.loader = true
      await this.getHoneyRoles()
      this.loader = false
    },
    async saveChanges() {
      if (!this.currentRole || !this.currentRole.privilege) return
      this.loader = true
      try {
        let saveRole = JSON.parse(JSON.stringify(this.currentRole))
        saveRole.privilege.table = this.tablePrivileges
          .filter(privilege => privilege.assigned)
          .map(privilege => privilege.role)
        saveRole.privilege.honey = this.honeyPrivileges
          .filter(privilege => privilege.assigned)
          .map(privilege => privilege.role)
        saveRole.privilege.api = this.apiPrivileges
          .filter(privilege => privilege.assigned)
          .map(privilege => privilege.role)
        await axios.put(`/api/v1/honeyRoles/${saveRole.hexId}`, saveRole)
        await this.getHoneyRoles()
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Changes saved successfully',
          description: 'Honey roles updated successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to save Changes',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.loader = false
    },
    syncPrivileges() {
      this.loader = true
      this.setPrivileges()
      this.loader = false
    },
    async getHoneyRoles() {
      this.loader = true
      try {
        await this.$store.dispatch('fetchHoneyRoles')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Roles',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.loader = false
    },
    async getPrivileges() {
      this.loader = true
      try {
        await this.$store.dispatch('fetchPrivileges')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Privileges',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.loader = false
    },
    setPrivileges: function() {
      if (!this.privileges.table) return
      this.tablePrivileges = this.privileges.table
        .filter(privilege => privilege !== 'SUPPORT' && privilege !== 'GENERIC')
        .map(privilege => {
          return { role: privilege, assigned: false }
        })
      this.honeyPrivileges = this.privileges.honey.map(privilege => {
        return { role: privilege, assigned: false }
      })
      this.apiPrivileges = this.privileges.api.map(privilege => {
        return { role: privilege, assigned: false }
      })
      this.syncPrivilegeMapping()
    },
    syncPrivilegeMapping() {
      if (!_.isArray(this.honeyRoles) || this.honeyRoles.length === 0) return
      this.currentRole = this.honeyRoles.find(role => role.hexId === this.id)
      if (!this.currentRole || !this.currentRole.privilege) return
      this.tablePrivileges = this.tablePrivileges.map(privilege => {
        privilege.assigned = this.currentRole.privilege.table.includes(
          privilege.role
        )
        return privilege
      })
      this.honeyPrivileges = this.honeyPrivileges.map(privilege => {
        privilege.assigned = this.currentRole.privilege.honey.includes(
          privilege.role
        )
        return privilege
      })
      this.apiPrivileges = this.apiPrivileges.map(privilege => {
        privilege.assigned = this.currentRole.privilege.api.includes(
          privilege.role
        )
        return privilege
      })
    }
  }
}
</script>

<style scoped></style>
